export default class DateFormatter {

    static FormatTransactionCardDate(time, now = new Date(Date.now())) {

        let d = new Date(time);

        let transactionDate = {
            "yyyy": d.getFullYear(),
            "mm": (d.getMonth() + 1).toString().length === 2 ? (d.getMonth() + 1) : "0" + (d.getMonth() + 1),
            "dd": d.getDate(),
            "hh": d.getHours(),
            "m": d.getMinutes(),
            "date": (d.getFullYear()) + "-" + ((d.getMonth() + 1).toString().length === 2 ? (d.getMonth() + 1) : "0" + (d.getMonth() + 1)) + "-" + (d.getDate().toString().length === 2 ? d.getDate() : "0" + d.getDate())
        };

        let todayDate = {
            "yyyy": now.getFullYear(),
            "mm": (now.getMonth() + 1).toString().length === 2 ? (now.getMonth() + 1) : "0" + (now.getMonth() + 1),
            "dd": now.getDate(),
            "hh": now.getHours(),
            "m": now.getMinutes()
        };

        let dateDifference = {
            "yyyy": todayDate["yyyy"] - transactionDate["yyyy"],
            "mm": todayDate["mm"] - transactionDate["mm"],
            "dd": todayDate["dd"] - transactionDate["dd"],
            "hh": todayDate["hh"] - transactionDate["hh"],
            "m": todayDate["m"] - transactionDate["m"]
        };

        if (dateDifference["yyyy"] !== 0) {
            return transactionDate["date"];
        } else {
            if (dateDifference["mm"] !== 0) {
                return transactionDate["date"];
            } else {
                if (dateDifference["dd"] === 1) {
                    return "Yesterday";
                } else if (dateDifference["dd"] !== 0) {
                    return transactionDate["date"];
                } else {
                    if (dateDifference["hh"] !== 0) {
                        if (dateDifference["hh"] === 1){
                            return dateDifference["hh"] + " hour ago";
                        } else {
                            return dateDifference["hh"] + " hours ago";
                        }
                    } else {
                        if (dateDifference["m"] !== 0) {
                            if (dateDifference["m"] === 1){
                                return dateDifference["m"] + " minute ago";
                            } else {
                                return dateDifference["m"] + " minutes ago";
                            }
                        } else {
                            return "Just now";
                        }
                    }
                }
            }
        }
    }

    // static formatDateTest() {
    //
    //     for (let i = 0; i < 100; i++) {
    //         let randomGeneratedDate = randomDate(new Date(2020, 2, 1, 0, 0, 0), new Date(Date.now()));
    //         console.log(this.FormatTransactionCardDate(randomGeneratedDate))
    //         console.log("------------------------------------------------")
    //     }
    //
    //     function randomDate(start, end) {
    //         return new Date(start.getTime() + Math.random() * (end.getTime() - start.getTime()));
    //     }
    // }
}